<template>
	<v-container class="background-2 pa-0 round-card pb-offset" fluid>
		<v-row class="ma-0 pa-0">
			<v-col cols="12" class="pa-0 ma-0">
				<v-card class="background-2 round-card mb-0 elevation-1 pa-1">
					<v-container class="pa-0" fluid>
						<v-subheader class="pl-5">
							Elenco Prodotti MEF
						</v-subheader>
						<v-divider></v-divider>
						<v-row class="ma-0">
							<v-col cols="12" md="4" class="pa-2">
								<v-text-field
									v-model="productsFilters.search"
									label="Cerca prodotto"
									append-icon="mdi-magnify"
									outlined
									dense
									hide-details
									clearable
									@input="debouncedLoadProducts"
								></v-text-field>
							</v-col>

							<v-col cols="12" md="3" class="pa-2">
								<v-autocomplete
									v-model="productsFilters.marca"
									:items="availableMarche"
									label="Marca"
									append-icon="mdi-tag"
									outlined
									dense
									hide-details
									clearable
									@change="loadMefProducts"
									:menu-props="{'offset-y': true}"
								></v-autocomplete>
							</v-col>

							<v-col cols="12" md="3" class="pa-2">
								<v-autocomplete
									v-model="productsFilters.fornitore_metel"
									:items="availableFornitori"
									label="Fornitore"
									append-icon="mdi-truck"
									outlined
									dense
									hide-details
									clearable
									@change="loadMefProducts"
									:menu-props="{'offset-y': true}"
								></v-autocomplete>
							</v-col>

							<v-col cols="12" md="2" class="pa-2">
								<v-select
									v-model="productsFilters.is_imported"
									:items="[
										{text: 'Tutti', value: null},
										{text: 'Importati', value: 1},
										{text: 'Non importati', value: 0}
									]"
									label="Stato"
									append-icon="mdi-filter"
									outlined
									dense
									hide-details
									@change="loadMefProducts"
									:menu-props="{'offset-y': true}"
								></v-select>
							</v-col>
						</v-row>
						<v-row class="ma-0 pa-0">
							<v-col cols="12" class="pa-0 ma-0">
								<v-data-table
									v-model="selectedProducts"
									:headers="productsHeaders"
									:items="mefProducts"
									:loading="loadingProducts"
									:server-items-length="totalProducts"
									:options.sync="productsOptions"
									show-select
									item-key="cod_art"
									class="elevation-0"
									:disable-sort="false"
									:footer-props="{
										'items-per-page-options': [10, 25, 50, 100, 500],
										showFirstLastPage: true
									}">
									<template v-slot:item.is_imported="{ item }">
										<v-chip
											small
											:color="item.is_imported ? 'success' : 'grey'"
											text-color="white"
										>
											{{ item.is_imported ? 'Importato' : 'Non importato' }}
										</v-chip>
									</template>

									<template v-slot:item.prezzo_l_pub="{ item }">
										{{ formatPrice(item.prezzo_l_pub) }}
									</template>

									<template v-slot:item.data_iniz_l_pub="{ item }">
										{{ formatDate(item.data_iniz_l_pub) }}
									</template>

									<template v-slot:item.data_fine_l_pub="{ item }">
										{{ formatDate(item.data_fine_l_pub) }}
									</template>

									<template v-slot:footer.page-text="{ pageStart, pageStop }">
										<div class="warning--text"><span class="warning--text">{{ selectedProducts.length }}</span> Selezionati</div>
										Da {{ pageStart }} a {{ pageStop }} di {{ totalProducts }}
									</template>
								</v-data-table>
							</v-col>
						</v-row>
						<v-col cols="12" class="pa-0 ma-0" v-if="showSelectAllBanner">
							<v-alert
								type="warning"
								dense
								text
								border="left"
								class="mb-0">
								Tutti i {{ mefProducts.length }} elementi di questa pagina sono selezionati.
								<a href="#" @click.prevent="selectAll = true" class="font-weight-bold">
									Seleziona tutti i {{ totalProducts }} prodotti che corrispondono ai filtri
								</a>
							</v-alert>
						</v-col>
						<v-col cols="12" class="pa-0 ma-0" v-else-if="selectAll">
							<v-alert
								type="success"
								dense
								text
								border="left"
								class="mb-0">
								<v-icon small left color="success">mdi-check-all</v-icon>
								Tutti i {{ totalProducts }} prodotti che corrispondono ai filtri sono selezionati.
								<a href="#" @click.prevent="selectAll = false; selectedProducts = []" class="font-weight-bold">
									Annulla selezione
								</a>
							</v-alert>
						</v-col>
						<v-col cols="12" class="pa-0 ma-0" v-else-if="selectedProducts.length > 0">
							<v-alert
								type="info"
								dense
								text
								border="left"
								class="mb-0">
								{{ selectedProducts.length }} {{ selectedProducts.length == 1 ? 'prodotto selezionato' : 'prodotti selezionati' }}
							</v-alert>
						</v-col>
					</v-container>


					<v-divider></v-divider>
					<v-card-actions>
						<v-chip class="px-6">
							<v-icon small left>mdi-package</v-icon>
							Totale: <strong class="pl-2">{{ totalProducts }}</strong>
						</v-chip>
						<v-chip  color="success" text-color="white" class="ml-2 px-6">
							<v-icon small left>mdi-check</v-icon>
							Importati: <strong class="pl-2">{{ importedCount }}</strong>
						</v-chip>
						<v-spacer></v-spacer>
						<v-btn
							color="primary"
							@click="importSelectedProducts"
							:disabled="!selectAll && (selectedProducts.length === 0 || selectedProducts.every(p => p.is_imported))"
							:loading="importing">
							<v-icon left>mdi-download</v-icon>
							Importa {{ selectAll ? 'Tutti' : 'Selezionati' }} ({{ importCount }})
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: 'mef-products-tab',

	data() {
		return {
			loadingProducts: false,
			importing: false,
			mefProducts: [],
			selectedProducts: [],
			selectAll: false,
			totalProducts: 0,
			importedCount: 0,
			availableMarche: [],
			availableFornitori: [],
			productsFilters: {
				search: '',
				marca: null,
				fornitore_metel: null,
				is_imported: null
			},
			productsOptions: {
				page: 1,
				itemsPerPage: 10,
				sortBy: ['cod_art'],
				sortDesc: [false]
			},
			productsHeaders: [
				{ text: 'Codice', value: 'cod_art', align: 'start' },
				{ text: 'Cod. Metel', value: 'cod_art_metel_interna' },
				{ text: 'Descrizione', value: 'descrizione_articolo', sortable: false },
				{ text: 'Marca', value: 'marca' },
				{ text: 'Fornitore', value: 'fornitore_metel' },
				{ text: 'Prezzo', value: 'prezzo_l_pub', align: 'end' },
				{ text: 'Prezzo x Qnt', value: 'prezzo_x_qta_l_pub', align: 'end' },
				{ text: 'Data Inizio', value: 'data_iniz_l_pub' },
				{ text: 'Stato', value: 'is_imported', align: 'center', sortable: false }
			],
			debounceTimer: null
		}
	},

	mounted() {
		this.loadMefProductsInfo()
	},

	computed: {
		allPageSelected() {
			if (this.mefProducts.length === 0) return false
			return this.mefProducts.every(p => this.selectedProducts.some(s => s.cod_art === p.cod_art))
		},
		showSelectAllBanner() {
			return this.allPageSelected && !this.selectAll && this.totalProducts > this.mefProducts.length
		},
		importCount() {
			if (this.selectAll) {
				// Se filtriamo solo gli importati, non possiamo importare nulla
				if (this.productsFilters.is_imported === 1) {
					return 0
				}
				// Altrimenti usiamo totalProducts (il backend salterà quelli già importati)
				return this.totalProducts
			}
			return this.selectedProducts.filter(p => !p.is_imported).length
		}
	},

	watch: {
		productsOptions: {
			handler() {
				this.loadMefProducts()
			},
			deep: true
		},
		productsFilters: {
			handler() {
				// Reset selectAll when filters change
				this.selectAll = false
			},
			deep: true
		},
		selectedProducts(newVal) {
			// Reset selectAll if user deselects products
			if (this.selectAll && newVal.length < this.mefProducts.length) {
				this.selectAll = false
			}
		}
	},

	methods: {
		loadMefProductsInfo() {
			this.axios.get('mef-products-info').then(response => {
				this.availableMarche = response.data.marche || []
				this.availableFornitori = response.data.fornitori || []
				this.totalProducts = response.data.total_products || 0
				this.importedCount = response.data.imported_products || 0
			}).catch(error => {
				console.error('Errore caricamento info prodotti MEF:', error)
			}).finally(() => {
				this.$store.commit('endProgress')
			})
		},

		loadMefProducts() {
			this.loadingProducts = true

			const { page, itemsPerPage, sortBy, sortDesc } = this.productsOptions

			const params = {
				page: page,
				itemsPerPage: itemsPerPage,
				sortBy: sortBy.length > 0 ? sortBy[0] : 'cod_art',
				sortDesc: sortDesc.length > 0 ? sortDesc[0] : false,
				...this.productsFilters
			}

			// Remove null values
			Object.keys(params).forEach(key => {
				if (params[key] === null || params[key] === '') {
					delete params[key]
				}
			})

			this.axios.post('mef-products-filters', params).then(response => {
				this.mefProducts = response.data.data || []
				this.totalProducts = response.data.total || 0
				this.loadingProducts = false
			}).catch(error => {
				this.loadingProducts = false
				console.error('Errore caricamento prodotti MEF:', error)
				this.$store.commit('setSnackbar', {
					timeout: 6000,
					text: 'Errore caricamento prodotti MEF',
					value: true,
					color: 'error'
				})
			})
		},

		debouncedLoadProducts() {
			clearTimeout(this.debounceTimer)
			this.debounceTimer = setTimeout(() => {
				this.loadMefProducts()
			}, 500)
		},

		importSelectedProducts() {
			this.importing = true

			let payload = {}

			if (this.selectAll) {
				// Pass all=true with current filters
				payload = {
					all: true,
					...this.getActiveFilters()
				}
			} else {
				const nonImportedProducts = this.selectedProducts.filter(p => !p.is_imported)

				if (nonImportedProducts.length === 0) {
					this.$store.commit('setSnackbar', {
						timeout: 6000,
						text: 'Tutti i prodotti selezionati sono già stati importati',
						value: true,
						color: 'warning'
					})
					this.importing = false
					return
				}

				payload = {
					cod_arts: nonImportedProducts.map(p => p.cod_art)
				}
			}

			this.axios.post('mef-products-import', payload).then(response => {
				this.importing = false

				if (response.data.success) {
					this.$store.commit('setSnackbar', {
						timeout: 6000,
						text: response.data.message,
						value: true,
						color: 'success'
					})

					// Reset selection and reload
					this.selectAll = false
					this.selectedProducts = []
					this.loadMefProducts()
					this.loadMefProductsInfo()
				} else {
					this.$store.commit('setSnackbar', {
						timeout: 6000,
						text: response.data.message || 'Errore durante importazione',
						value: true,
						color: 'error'
					})
				}
			}).catch(error => {
				this.importing = false
				console.error('Errore importazione prodotti:', error)
				this.$store.commit('setSnackbar', {
					timeout: 6000,
					text: error.response?.data?.message || 'Errore durante importazione prodotti',
					value: true,
					color: 'error'
				})
			})
		},

		getActiveFilters() {
			const filters = {}
			if (this.productsFilters.search) {
				filters.search = this.productsFilters.search
			}
			if (this.productsFilters.marca) {
				filters.marca = this.productsFilters.marca
			}
			if (this.productsFilters.fornitore_metel) {
				filters.fornitore_metel = this.productsFilters.fornitore_metel
			}
			if (this.productsFilters.is_imported !== null) {
				filters.is_imported = this.productsFilters.is_imported
			}
			return filters
		},

		formatPrice(price) {
			if (!price) return '-'
			return '€ ' + parseFloat(price).toFixed(2)
		},

		formatDate(date) {
			if (!date) return '-'
			return new Date(date).toLocaleDateString('it-IT')
		}
	}
}
</script>
